import { render } from "./NewCandidacy.vue?vue&type=template&id=615bd371&scoped=true"
import script from "./NewCandidacy.vue?vue&type=script&lang=js"
export * from "./NewCandidacy.vue?vue&type=script&lang=js"

import "./NewCandidacy.vue?vue&type=style&index=0&id=615bd371&scoped=true&lang=css"

import exportComponent from "/var/www/html/remote/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615bd371"]])

export default __exports__